import React from 'react';
import { OverviewHeader, DataCard } from '@brighterion/br-ui';
import styles from './AddRuleOverview.css';

type Props = Omit<React.ComponentProps<typeof OverviewHeader>, 'children'> & {
    topData?: React.ComponentProps<typeof DataCard>[];
    bottomData?: React.ComponentProps<typeof DataCard>[];
    middleData?: React.ComponentProps<typeof DataCard>[];
    children?: React.ReactNode;
    isLandlord?: boolean;
};
const AddRuleOverview = ({
    leftTitle,
    rightTitle,
    topData,
    bottomData,
    dataTestId,
    children,
    middleData,
    isLandlord
}: Props) => {
    return (
        <OverviewHeader
            dataTestId={dataTestId}
            leftTitle={leftTitle}
            rightTitle={rightTitle}
            containerClassName={styles.overviewHeader}
        >
            {children ? (
                <>{children}</>
            ) : (
                <div className={isLandlord ? styles.overviewForLeftRight : styles.overviewForLeftRightWIthoutWidth}>
                    <div className={styles.overviewWrapper}>
                        <div className={styles.left}>
                            {topData?.map((o) => {
                                return (
                                    <div className={styles.leftCard} key={o?.label}>
                                        {o?.data}
                                    </div>
                                );
                            })}
                        </div>
                        <div className={styles.left}>
                            {bottomData?.map((o) => {
                                return (
                                    <div className={styles.leftCard} key={o?.label}>
                                        {o?.data}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className={styles.middle}>
                        {middleData?.map((o) => {
                            return (
                                <div className={styles.middleleftCard} key={o?.label}>
                                    {o?.data}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </OverviewHeader>
    );
};

export default React.memo(AddRuleOverview);
